import React from 'react';

// Componente de Producto Individual
function ProductCard({ product }) {
  // Crear lista de presentaciones para el mensaje de WhatsApp
  const presentations = product.sizes.map(s => s.size).join(', ');

  return (
    <div className="product-card mb-50">
      <div className="product-image fit-img">
        <img
          src={product.image}
          alt={product.name}
          className="product-main-image"
        />
      </div>
      <div className="product-info pt-30">
        <div className="product-category mb-15">
          <span className="main-color">{product.category}</span>
        </div>
        <h4 className="product-title">{product.name}</h4>
        <p className="product-description mt-20 mb-30">
          {product.description}
        </p>
        {/* Presentaciones - Solo descripción visual */}
        <div className="product-sizes mb-30">
          <div className="sizes-label mb-15">
            <span className="text-light fw-500">Presentación:</span>
          </div>
          <div className="sizes-buttons">
            {product.sizes.map((size, index) => (
              <span key={index} className="size-btn">
                {size.size}
              </span>
            ))}
          </div>
        </div>
        <a
          href={`https://wa.me/573115742189?text=Hola, me interesa solicitar información sobre ${product.name}. Presentaciones disponibles: ${presentations}`}
          target="_blank"
          rel="noopener noreferrer"
          className="butn butn-sm butn-bord w-100 text-center"
        >
          <span>Solicitar via WhatsApp</span>
        </a>
      </div>
    </div>
  );
}

function Blog() {
  const products = [
    {
      name: "Jugo de Mandarina",
      category: "Jugos Cítricos",
      image: "/assets/imgs/productos/definitivos/mandarina.jpg",
      description: "100% Jugo de mandarina. Producto listo para el consumo.",
      sizes: [
        { size: "1L", price: 16000 },
        { size: "3L (Bolsa)", price: 45000 },
        { size: "3L (Garrafa)", price: 45000 },
        { size: "5L (Bolsa)", price: 68000 },
        { size: "5L (Garrafa)", price: 68000 }
      ],
      link: "/producto-mandarina"
    },
    {
      name: "Jugo de Naranja",
      category: "Jugos Cítricos",
      image: "/assets/imgs/productos/definitivos/naranja.jpg",
      description: "100% Jugo de naranja. Producto listo para el consumo.",
      sizes: [
        { size: "1L", price: 15000 },
        { size: "3L (Bolsa)", price: 38000 },
        { size: "3L (Garrafa)", price: 38000 },
        { size: "5L (Bolsa)", price: 58000 },
        { size: "5L (Garrafa)", price: 58000 }
      ],
      link: "/producto-naranja"
    },
    {
      name: "Zumo de Limón",
      category: "Jugos Cítricos",
      image: "/assets/imgs/productos/definitivos/limon.jpg",
      description: "100% Jugo de limón. Producto listo para el consumo.",
      sizes: [
        { size: "1L", price: 14000 },
        { size: "3L (Bolsa)", price: 35000 },
        { size: "3L (Garrafa)", price: 35000 },
        { size: "5L (Bolsa)", price: 52000 },
        { size: "5L (Garrafa)", price: 52000 }
      ],
      link: "/producto-limon"
    },
    {
      name: "Zumo de Toronja Rosada",
      category: "Jugos Cítricos",
      image: "/assets/imgs/productos/definitivos/toronja.jpg",
      description: "100% Jugo de toronja rosada. Producto listo para el consumo.",
      sizes: [
        { size: "1L", price: 17000 },
        { size: "3L", price: 48000 }
      ],
      link: "/producto-toronja"
    },
    {
      name: "Zumo de Limón Mandarino",
      category: "Jugos Cítricos",
      image: "/assets/imgs/productos/definitivos/limonmandarino.jpg",
      description: "100% Jugo de limón mandarino. Producto listo para el consumo.",
      sizes: [
        { size: "1L", price: 18000 },
        { size: "3L", price: 50000 }
      ],
      link: "/producto-limon-mandarino"
    },
    {
      name: "Limonada de Coco",
      category: "Bebidas Tropicales",
      image: "/assets/imgs/productos/definitivos/coco.jpg",
      description: "100% Limonada de coco. Producto listo para el consumo.",
      sizes: [
        { size: "1L", price: 20000 },
        { size: "3L (Bolsa)", price: 55000 },
        { size: "3L (Garrafa)", price: 55000 },
        { size: "5L (Bolsa)", price: 85000 },
        { size: "5L (Garrafa)", price: 85000 }
      ],
      link: "/producto-limonada-coco"
    },
    {
      name: "Limonada Cerezada",
      category: "Bebidas Tropicales",
      image: "/assets/imgs/productos/definitivos/cerezada.jpg",
      description: "100% Limonada cerezada. Producto listo para el consumo.",
      sizes: [
        { size: "1L", price: 20000 },
        { size: "3L (Bolsa)", price: 55000 },
        { size: "3L (Garrafa)", price: 55000 },
        { size: "5L (Bolsa)", price: 85000 },
        { size: "5L (Garrafa)", price: 85000 }
      ],
      link: "/producto-limonada-cerezada"
    },
    {
      name: "Limonada con Hierbabuena",
      category: "Bebidas Tropicales",
      image: "/assets/imgs/productos/definitivos/limonhierbabuena.jpg",
      description: "100% Limonada con hierbabuena. Producto listo para el consumo.",
      sizes: [
        { size: "1L", price: 20000 },
        { size: "3L (Bolsa)", price: 55000 },
        { size: "3L (Garrafa)", price: 55000 },
        { size: "5L (Bolsa)", price: 85000 },
        { size: "5L (Garrafa)", price: 85000 }
      ],
      link: "/producto-limonada-hierbabuena"
    }
  ];

  const pulpas = [
    {
      name: "Pulpa de Fresa",
      category: "Bolsas Naturales",
      image: "/assets/imgs/pulpas/citricos-naturales-pulpas-naturales-fresa.avif",
      description: "100% Pulpa natural de fresa.",
      sizes: [
        { size: "12 unidades" },
        { size: "125 gramos" }
      ],
    },
    {
      name: "Pulpa de Guanábana",
      category: "Bolsas Naturales",
      image: "/assets/imgs/pulpas/citricos-naturales-pulpas-naturales-guanabana.avif",
      description: "100% Pulpa natural de guanábana.",
      sizes: [
        { size: "12 unidades" },
        { size: "125 gramos" }
      ],
    },
    {
      name: "Pulpa de Lulo",
      category: "Bolsas Naturales",
      image: "/assets/imgs/pulpas/citricos-naturales-pulpas-naturales-lulo.avif",
      description: "100% Pulpa natural de lulo.",
      sizes: [
        { size: "12 unidades" },
        { size: "125 gramos" }
      ],
    },
    {
      name: "Pulpa de Mango",
      category: "Bolsas Naturales",
      image: "/assets/imgs/pulpas/citricos-naturales-pulpas-naturales-mango.avif",
      description: "100% Pulpa natural de mango.",
      sizes: [
        { size: "12 unidades" },
        { size: "125 gramos" }
      ],
    },
    {
      name: "Pulpa de Maracuyá",
      category: "Bolsas Naturales",
      image: "/assets/imgs/pulpas/citricos-naturales-pulpas-naturales-maracuya.avif",
      description: "100% Pulpa natural de maracuyá.",
      sizes: [
        { size: "12 unidades" },
        { size: "125 gramos" }
      ],
    },
    {
      name: "Pulpa de Mora",
      category: "Bolsas Naturales",
      image: "/assets/imgs/pulpas/citricos-naturales-pulpas-naturales-mora.avif",
      description: "100% Pulpa natural de mora.",
      sizes: [
        { size: "12 unidades" },
        { size: "125 gramos" }
      ],
    }
  ];

  return (
    <section id="productos" className="blog section-padding">
      <div className="container">
        <div className="sec-head mb-80">
          <div className="row align-items-center">
            <div className="col-lg-9">
              <span className="sub-title main-color mb-5">Productos</span>
              <h3 className="fw-600 fz-50 text-u d-rotate wow">
                <span className="rotate-text">
                  Nuestro <span className="fw-200">Catálogo</span>
                </span>
              </h3>
              <p className="fz-20 text-light-gray mt-20">
                Nuestros jugos y zumos son elaborados con los más altos estándares de calidad.
                Cada botella contiene el equilibrio perfecto entre sabor natural y frescura, sin conservantes ni aditivos artificiales
              </p>
            </div>
            <div className="col-lg-3 text-lg-end">
              <a
                href="/assets/docs/Cátalogo de Productos - Cítricos Naturales S.A.S.pdf"
                download="Cátalogo de Productos - Cítricos Naturales S.A.S.pdf"
                className="butn butn-sm butn-bord pulse-animation"
              >
                <span>Catálogo PDF</span>
              </a>
            </div>
          </div>
        </div>
        <style jsx>{`
          :root { --main-color-rgb: 255, 152, 0; }
          @keyframes pulseButton { 0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(var(--main-color-rgb), 0.4); } 70% { transform: scale(1.05); box-shadow: 0 0 0 10px rgba(var(--main-color-rgb), 0); } 100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(var(--main-color-rgb), 0); } }
          .pulse-animation { animation: pulseButton 3s infinite; }
          .pulse-animation:hover { animation: none; transform: scale(1.05); transition: transform 0.3s ease; }
          .sizes-buttons .size-btn { cursor: default; pointer-events: none; user-select: none; }
          .sizes-buttons .size-btn:hover { transform: none; }
          @media screen and (max-width: 991px) {
            .sec-head .col-lg-3 {
              margin-top: 30px;
            }
          }
          @media screen and (max-width: 768px) {
            #productos p,
            #productos .product-description {
              text-align: justify !important;
            }
          }
        `}</style>
        <div className="row">
          {products.map((product, index) => (
            <div key={index} className="col-lg-4 col-md-6 col-sm-12">
              <ProductCard product={product} />
            </div>
          ))}
        </div>

        {/* Divider and Title for Pulpas */}
        <div className="row mt-80 mb-50">
          <div className="col-12">
            <hr style={{ borderColor: 'rgba(255, 255, 255, 0.1)', opacity: 0.5, marginBottom: '50px' }} />
            <div className="sec-head">
              <div className="row align-items-center">
                <div className="col-lg-9">
                  <span className="sub-title main-color mb-5">Productos</span>
                  <h3 className="fw-600 fz-50 text-u d-rotate wow animated">
                    <span className="rotate-text">
                      Bolsas <span className="fw-200">Naturales</span>
                    </span>
                  </h3>
                  <p className="fz-20 text-light-gray mt-20">
                    Congeladas en prácticas porciones individuales de 125 gramos, son la solución perfecta, rápida y saludable para cualquier tipo de ocasión.
                  </p>
                </div>
                <div className="col-lg-3 text-lg-end">
                  <a
                    href="/assets/docs/Cátalogo de Productos - Cítricos Naturales S.A.S.pdf"
                    download="Cátalogo de Productos - Cítricos Naturales S.A.S.pdf"
                    className="butn butn-sm butn-bord pulse-animation"
                  >
                    <span>Catálogo PDF</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          {pulpas.map((product, index) => (
            <div key={`pulpa-${index}`} className="col-lg-4 col-md-6 col-sm-12">
              <ProductCard product={product} />
            </div>
          ))}
        </div>
        {/* INVIMA Section */}
        <div className="invima-info mt-80 d-flex align-items-center" style={{ backgroundColor: 'rgba(255, 255, 255, 0.02)', padding: '40px', border: '1px solid rgba(255, 255, 255, 0.1)' }}>
          <img src="/assets/imgs/productos/invima-logo.png" alt="INVIMA" className="mr-30" style={{ width: '100px', height: 'auto', filter: 'brightness(0) invert(1)' }} />
          <div>
            <h3 className="fw-600 fz-30 text-u mb-10" style={{ color: '#fff' }}>AVALADOS</h3>
            <p className="mb-0" style={{ color: '#c6c8c9' }}>
              Nuestros productos cuentan con concepto sanitario y registro sanitario otorgado por el INVIMA (Colombia), garantizando la calidad y seguridad para el consumo.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Blog;
